import { routeUrl } from "@/app/routes";
import {
  READ_CARD_ROW_LIMIT,
  ReadCardFrame,
} from "@/features/copilot/components/read-cards/read-card-frame";
import type { TodoItem } from "@/features/copilot/schemas/copilot-read-cards.schema";
import { formatDateOnly } from "@/shared/lib/format-date-only";

/// Total over today's statuses; anything new reads as "Todo" rather than leaking a raw enum.
const TODO_STATUS_LABEL: Record<string, string> = {
  open: "Open",
  in_progress: "In progress",
  completed: "Done",
};

function todoMeta(todo: TodoItem): string {
  const due = formatDateOnly(todo.dueDate ?? null);
  return [
    TODO_STATUS_LABEL[todo.status] ?? "Todo",
    due ? `Due ${due}` : null,
    todo.assignees?.[0]?.name ?? null,
  ]
    .filter((part): part is string => part !== null)
    .join(" · ");
}

export function TodosReadCard({
  items,
  slug,
  hasMore = false,
}: {
  items: TodoItem[];
  slug: string;
  hasMore?: boolean;
}) {
  const shown = items.slice(0, READ_CARD_ROW_LIMIT);
  return (
    <ReadCardFrame
      title="Todos"
      viewAllHref={routeUrl.todos.list(slug)}
      hiddenCount={items.length - shown.length}
      hasMore={hasMore}
    >
      {shown.map((todo) => (
        <li key={todo.id}>
          <a
            href={routeUrl.todos.detail(slug, todo.id)}
            className="block space-y-0.5 px-3 py-2 hover:bg-muted/60 focus-visible:outline-2 focus-visible:outline-ring"
          >
            <span className="line-clamp-2 break-words">{todo.title}</span>
            <span className="block truncate text-xs text-text-secondary">{todoMeta(todo)}</span>
          </a>
        </li>
      ))}
    </ReadCardFrame>
  );
}
